import React from "react";
import { cn } from "../../lib/utils";

function Textarea({ className, error, ref, ...props }) {
  return (
    <textarea
      ref={ref}
      className={cn(
        // .form-textarea
        "block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm shadow-sm text-primary-900 placeholder:text-gray-400 transition-colors resize-y min-h-[80px]",
        "focus:outline-none focus:ring-1 focus:ring-primary-900 focus:border-primary-900",
        "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-gray-50",
        // .form-input-error
        error && "border-danger-900 focus:border-danger-900 focus:ring-danger-900",
        className
      )}
      {...props}
    />
  );
}

export { Textarea };
